import axios from 'axios'
import type { SearchResult } from '@/types/types'

export default class {
  static async search(query: string) {
    return axios.get<SearchResult>(`search/${query}`)
  }
}
